import { Trans, useTranslation } from 'react-i18next';

import { Modal } from '@talend/design-system';

import { I18N_NAME_SPACE } from '../../../../constants';
import { CAD_TYPES } from '../../CAD.types';

function getDeleteButtonDataFeature(type?: CAD_TYPES): string {
	switch (type) {
		case CAD_TYPES.TEXT:
			return 'custom_attribute.text.remove';
		default:
			return 'custom_attribute.value_list.remove';
	}
}

export interface CADDeleteDialogProps {
	id: string;
	label: string;
	type?: CAD_TYPES;
	onCancel: () => void;
	onValidate: (id: string, label: string) => void;
	inProgress?: boolean;
	show?: boolean;
}

export function CADDeleteDialog({
	id,
	label,
	type,
	onCancel,
	onValidate,
	inProgress,
	show,
}: CADDeleteDialogProps) {
	const { t } = useTranslation(I18N_NAME_SPACE);

	if (!show) return null;

	return (
		<Modal
			preventEscaping={inProgress}
			header={{ title: t('DELETE_CUSTOM_ATTRIBUTE_DIALOG_HEADER', 'Remove custom attribute') }}
			onClose={onCancel}
			primaryAction={{
				children: t('DELETE_CUSTOM_ATTRIBUTE_DIALOG_VALIDATE', 'REMOVE'),
				onClick: () => {
					onValidate(id, label);
				},
				destructive: true,
				isLoading: inProgress,
				['data-feature']: getDeleteButtonDataFeature(type),
			}}
		>
			<Trans i18nKey="tdc-app:DELETE_CUSTOM_ATTRIBUTE_DIALOG_BODY">
				{/* @ts-ignore */}
				Are you sure you want to remove the custom attribute <strong>{{ label }}</strong>?
			</Trans>
		</Modal>
	);
}

CADDeleteDialog.displayName = 'CADDeleteDialog';
